/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
 */
export interface CreateRecordingEnvelopePayloadRecordingDupIsrcsInner {
    /**
     * Recording ID the ISRC is being reassigned from
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
     */
    dupRecordingId: string;
    /**
     * OpenSearch document ID of the source recording
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
     */
    dupDocumentId: string;
    /**
     * ISRCs (all in `recording.isrcs`) being reassigned from this recording
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
     */
    isrcs: Array<string>;
}

/**
 * Check if a given object implements the CreateRecordingEnvelopePayloadRecordingDupIsrcsInner interface.
 */
export function instanceOfCreateRecordingEnvelopePayloadRecordingDupIsrcsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dupRecordingId" in value;
    isInstance = isInstance && "dupDocumentId" in value;
    isInstance = isInstance && "isrcs" in value;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSON(json: any): CreateRecordingEnvelopePayloadRecordingDupIsrcsInner {
    return CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayloadRecordingDupIsrcsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dupRecordingId': json['dup_recording_id'],
        'dupDocumentId': json['dup_document_id'],
        'isrcs': json['isrcs'],
    };
}

export function CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerToJSON(value?: CreateRecordingEnvelopePayloadRecordingDupIsrcsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dup_recording_id': value.dupRecordingId,
        'dup_document_id': value.dupDocumentId,
        'isrcs': value.isrcs,
    };
}

